import {Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {MyReferralsEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTheme} from 'styled-components';
import {StyledCardContainer, StyledHeader} from './styles';
import { MyReferralsTaggingEnum } from 'main/analytics/gaTagsEnum';

const {myReferralsCard} = translations['pt-br'].privateFlow.home;

export function MyReferralsCard() {
	const theme = useTheme();
	const navigate = useNavigate();

	const goToMyReferralsPage = () => {
		navigate(MyReferralsEnum.MY_REFERRALS);
	};

	return (
		<StyledCardContainer elevation={0}>
			<StyledHeader>
				<Typography variant="body2" component={'span'} color="text.primary">
					{myReferralsCard.line1}
				</Typography>
				<IconIllustration
					variant="primary"
					customIconName="assignment-outline"
					size="small"
				/>
			</StyledHeader>
			<Typography
				variant="body2"
				component={'span'}
				color={theme.palette.primary.main}
				alignSelf={'flex-end'}
				fontWeight={600}
				sx={{cursor: 'pointer'}}
				data-tag-id={MyReferralsTaggingEnum.CLICK_ACESSAR_MEUS_ENCAMINHAMENTOS_CARD}
				onClick={goToMyReferralsPage}>
				{myReferralsCard.seeReferrals}
			</Typography>
		</StyledCardContainer>
	);
}
